import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

const MUTED = "#7A7570"

// Doughnut chart with a side legend and percentage tooltips.
export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    values: Array,
    colors: Array,
    unit: { type: String, default: "raw" },
  }

  connect() {
    const total = this.valuesValue.reduce((a, b) => a + b, 0) || 1
    const fmt = (v) => this.format(v)

    this.chart = new Chart(this.canvasTarget, {
      type: "doughnut",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            data: this.valuesValue,
            backgroundColor: this.colorsValue,
            borderColor: "#fff",
            borderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "60%",
        plugins: {
          legend: { position: "right", labels: { color: MUTED, boxWidth: 12, font: { size: 11 } } },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.label}: ${fmt(ctx.parsed)} (${Math.round((ctx.parsed / total) * 100)}%)`,
            },
          },
        },
      },
    })
  }

  format(v) {
    if (this.unitValue === "tonnes") return `${(v / 1000).toFixed(1)}t`
    if (this.unitValue === "kg") return `${Math.round(v)} kg`
    return `${Math.round(v)}`
  }

  disconnect() {
    this.chart?.destroy()
  }
}
